import React, { useEffect, useState } from 'react';
import { isEmpty, map, orderBy, size } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table, Popover } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveColumnsByName } from '../../../redux/selectors/household-member-column';
import { fetchHouseholdMemberColumns } from '../../../redux/sagas/household-member-column/routines';
import CustomFieldCell from '../../widgets/custom-cell/CustomFieldCell';

const { Column, HeaderCell } = Table;

const computeHeight = (itemsCount = 0, rowHeight = 42, initialHeight = 60) => {
  const maxCount = 5;
  const count = itemsCount >= maxCount ? maxCount : itemsCount;
  return initialHeight + count * rowHeight;
};

const HouseholdMembersPopover = ({ data, ...props }) => {
  const dispatch = useDispatch();
  const columns = useSelector(getActiveColumnsByName);
  const [sortType, setSortType] = useState('asc');
  const [sortColumn, setSortColumn] = useState('name');

  useEffect(
    () => {
      if (isEmpty(columns)) dispatch(fetchHouseholdMemberColumns());
    },
    [columns]
  );

  const handleSortColumn = (column, type) => {
    setSortType(type);
    setSortColumn(column);
  };

  return (
    <Popover title="Members" {...props}>
      <Table
        width={800}
        height={computeHeight(size(data))}
        data={orderBy(sortColumn, sortType, data)}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
      >
        {map(
          ({ name, label }) => (
            <Column key={`field-${name}`} width={100} sortable resizable>
              <HeaderCell>{label}</HeaderCell>
              <CustomFieldCell dataKey={name} colSettings={columns[name]} />
            </Column>
          ),
          columns
        )}
      </Table>
    </Popover>
  );
};

HouseholdMembersPopover.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default HouseholdMembersPopover;
